import type { CSSProperties } from 'react';

interface Props {
  className?: string;
  style?: CSSProperties;
}

const SearchingState = ({ className, style }: Props) => {
  return (
    <div className={className} style={style}>
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="h-32 bg-gray-200 animate-pulse rounded-lg" />
      ))}
    </div>
  );
};

export default SearchingState;
